import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBXEyzkhuNeC16_ydFMw8VHA8pjMZ9NsGI",
  authDomain: "opskrifter-7171d.firebaseapp.com",
  databaseURL: "https://opskrifter-7171d.firebaseio.com",
  projectId: "opskrifter-7171d",
  storageBucket: "opskrifter-7171d.appspot.com",
  messagingSenderId: "1037492760758",
  appId: "1:1037492760758:web:f9efefbce43b13a5483617",
  measurementId: "G-XBZRV1LPPK"
});

const auth = firebase.auth()
const db = firebaseApp.firestore()

export { db, auth }